import { UIUtilsChat } from '../../../../shared/scripts/ui_chat/UIUtilsChat.ts';
import { UIChatPost } from '../../../../shared/scripts/ui_chat/UIChatPost.ts';
import { AccessLevel, CHAT_MAXIMUM_CHARACTER_LIMIT, LobbyImage } from '@colonist/types';
import { setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { isValueRequiredAccessLevel } from '@colonist/validation';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import IconSoundOn from '@static/images/icon_sound_on.svg';
import IconSoundOff from '@static/images/icon_sound_off.svg';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIRoomChatController {
    setSound() {
        setElementOnClick(this.muteButton, ()=>{
            AudioManager.toggleMute();
            this.muteButton.src = AudioManager.isMuted ? IconSoundOff : IconSoundOn;
        });
        this.muteButton.src = AudioManager.isMuted ? IconSoundOff : IconSoundOn;
    }
    clear() {
        setElementInnerHTML(this.chatContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
    }
    isChatAllowed() {
        if (this.chatInput.value == '') return false;
        return true;
    }
    sendChat() {
        const debugClientText = UIUtilsChat.getDebugClientText(this.chatInput.value);
        if (debugClientText != undefined) this.post({
            text: debugClientText,
            icon: LobbyImage.Admin
        });
        if (!this.isChatAllowed()) return;
        socket.roomClient.submitChatText(this.chatInput.value);
        this.chatInput.value = '';
    }
    post(chatData) {
        UIChatPost.post(this.chatContainer, chatData, undefined, undefined);
    }
    postMessage(message, senderUsername, senderIcon) {
        const chatData = {
            icon: senderIcon,
            text: {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: message,
                    interpolation: {
                        escapeValue: false
                    }
                }
            },
            colorAndBoldUsernames: true,
            username: senderUsername
        };
        UIChatPost.post(this.chatContainer, chatData, undefined, undefined);
    }
    constructor(){
        var _ClientUserState_userState;
        this.chatContainer = document.getElementById('scene_room_right_message_container');
        this.chatForm = document.getElementById('lobby_chat_form');
        this.chatInput = document.getElementById('lobby_chat_input');
        this.chatButton = document.getElementById('lobby_chat_button');
        this.muteButton = document.getElementById('lobby_chat_mute_button');
        this.chatForm.onsubmit = (e)=>{
            e.preventDefault();
            this.sendChat();
        };
        if (!isValueRequiredAccessLevel((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.accessLevel, AccessLevel.Moderator)) {
            this.chatInput.maxLength = CHAT_MAXIMUM_CHARACTER_LIMIT;
        }
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) this.chatButton.classList.add('send-chat-button-mobile');
        setElementOnClick(this.chatButton, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendChat();
        });
        this.setSound();
    }
}
